import { StringParam, useQueryParams, withDefault, DelimitedArrayParam } from 'use-query-params';

import { INSIGHTS_QUERY_KEY } from '@insights_module/constants/queryKeys';
import { FilterStateType, NamedEntityKey } from '@insights_module/types/ContextualAndEntity';

export const useGroupParams = () => {
  const [query, setQuery] = useQueryParams({
    [INSIGHTS_QUERY_KEY.name]: withDefault(StringParam, null),
    [INSIGHTS_QUERY_KEY.duration]: withDefault(StringParam, null),
    [INSIGHTS_QUERY_KEY.include_named_entities]: withDefault(DelimitedArrayParam, []),
    [INSIGHTS_QUERY_KEY.exclude_named_entities]: withDefault(DelimitedArrayParam, []),
    [INSIGHTS_QUERY_KEY.include_linked_named_entities]: withDefault(StringParam, null),
    [INSIGHTS_QUERY_KEY.exclude_linked_named_entities]: withDefault(StringParam, null),
    [INSIGHTS_QUERY_KEY.include_keywords]: withDefault(DelimitedArrayParam, []),
    [INSIGHTS_QUERY_KEY.exclude_keywords]: withDefault(DelimitedArrayParam, []),
    [INSIGHTS_QUERY_KEY.include_topics]: withDefault(DelimitedArrayParam, []),
    [INSIGHTS_QUERY_KEY.exclude_topics]: withDefault(DelimitedArrayParam, []),
    [INSIGHTS_QUERY_KEY.include_text]: withDefault(DelimitedArrayParam, []),
    [INSIGHTS_QUERY_KEY.exclude_text]: withDefault(DelimitedArrayParam, []),
  });

  function setNamedEntity(key: NamedEntityKey, value: FilterStateType) {
    const includedNamedEntities = query[INSIGHTS_QUERY_KEY.include_named_entities] as Array<string>;
    const excludedNamedEntities = query[INSIGHTS_QUERY_KEY.exclude_named_entities] as Array<string>;

    if (value === 'includes' && !includedNamedEntities?.includes(key)) {
      setQuery({ [INSIGHTS_QUERY_KEY.include_named_entities]: [...includedNamedEntities, key] });
    }
    if (value === 'excludes' && !excludedNamedEntities?.includes(key)) {
      setQuery({ [INSIGHTS_QUERY_KEY.exclude_named_entities]: [...excludedNamedEntities, key] });
    }
    if (value === 'ignore') {
      if (includedNamedEntities?.includes(key)) {
        if (includedNamedEntities.length === 1) {
          setQuery({ [INSIGHTS_QUERY_KEY.include_named_entities]: undefined });
          return;
        }
        setQuery({
          [INSIGHTS_QUERY_KEY.include_named_entities]: includedNamedEntities.filter(
            (item) => item !== key
          ),
        });
      }
      if (excludedNamedEntities?.includes(key)) {
        if (excludedNamedEntities.length === 1) {
          setQuery({ [INSIGHTS_QUERY_KEY.exclude_named_entities]: undefined });
          return;
        }
        setQuery({
          [INSIGHTS_QUERY_KEY.exclude_named_entities]: excludedNamedEntities.filter(
            (item) => item !== key
          ),
        });
      }
    }
  }

  function setAllNamedEntities({
    includes,
    excludes,
  }: {
    includes: Array<string>;
    excludes: Array<string>;
  }) {
    setQuery({
      [INSIGHTS_QUERY_KEY.include_named_entities]: includes,
      [INSIGHTS_QUERY_KEY.exclude_named_entities]: excludes,
    });
  }

  function resetAllNamedEntities() {
    setQuery({
      [INSIGHTS_QUERY_KEY.include_named_entities]: undefined,
      [INSIGHTS_QUERY_KEY.exclude_named_entities]: undefined,
    });
  }

  return {
    groupParams: query,
    setGroupParams: setQuery,
    setNamedEntity,
    resetAllNamedEntities,
    setAllNamedEntities,
  };
};
